module.exports = __webpack_public_path__ + "img/associate.68c0114e.svg";